import React from "react";
import PropTypes from "prop-types";

/** returns a button to download PDF link */
export const DownloadButtonComponent = ({ link, label, customClass }) => {
  return (
    <a type="button" className={customClass} href={link}>
      {label}
    </a>
  );
};

/**
 * Allowed Props
 */
DownloadButtonComponent.propTypes = {
  link: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
};

/** Specifies the default values for props: */
DownloadButtonComponent.defaultProps = {
  customClass: "btn btn-blue btn-agreement",
};



// WEBPACK FOOTER //
// ./src/modules/AppCore/Component/Buttons/DownloadButtonComponent.js